module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAIAAAD9b0jDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGRJREFUeNpi/P//PwO1ARMDDcCooaOGEgAXH343rbyuUXh16s7Xo2E6MIYyYi1QXn78HTHx/vP3v/FrnpQg66bPN6AuxUxSKTMefP7xL9dDLNtddDT2B02SGg3TUUMHl6EAAQYANd0l/iYmQ6wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/maptool/ZOOMOUT_V.png
// module id = gJxw
// module chunks = 18